<template>
  <div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth">
        <div class="row flex-grow">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left p-5">
              <div class="brand-logo">
                <img src="../../assets/images/maxcess-logo.png" />
              </div>
              <h4>OTP Verification</h4>
              <h6 class="font-weight-light">Hello Username.</h6>
              <label
                class="form-check-label text-muted"
                style="font-size: 0.8rem"
                >Thank you for registering with us. Please enter th OTP as
                shared on email
                {{
                  auth_store.registed_user == null
                    ? ""
                    : auth_store.registed_user.usr_email
                }}
              </label>
              <!-- {{ auth_store.registed_user.usr_email }} -->

              <BForm class="mt-2">
                <div class="form-group">
                  <InputOtp
                    v-model="otp_number"
                    :length="6"
                    integerOnly
                    style="margin: 0; padding: 0"
                    id="input_otp"
                    :state="is_valid_otp"
                  />
                </div>
                <BFormInvalidFeedback id="input_otp">
                  Enter OTP
                </BFormInvalidFeedback>
              </BForm>
              <div class="mt-3">
                <a
                  class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"
                  @click="verifyOTP"
                  >Verify Me</a
                >
              </div>
              <div class="text-center mt-4 font-weight-light">
                OTP not received?
                <a
                  @click="resend_otp"
                  :class="is_timer_On ? 'not-active' : 'text-primary'"
                  >Resend</a
                ><span v-if="is_timer_On"> OTP in {{ time_left }} </span>
              </div>
              <!-- <form class="pt-3">
                                <div class="form-group">
                                    <div id="otp" class="inputs d-flex flex-row justify-content-center mt-2">
                                        <BFormInput class="m-2 text-center form-control " type="text" id="first"
                                            maxlength="1" v-on:keyup.enter="goNext($event.target)" />
                                        <BFormInput class="m-2 text-center form-control " type="text" id="second"
                                            maxlength="1" v-on:keyup.enter="goNext($event.target)" />
                                        <BFormInput class="m-2 text-center form-control " type="text" id="third"
                                            maxlength="1" v-on:keyup.enter="goNext($event.target)" />
                                        <BFormInput class="m-2 text-center form-control " type="text" id="fourth"
                                            maxlength="1" v-on:keyup.enter="goNext($event.target)" />
                                        <BFormInput class="m-2 text-center form-control " type="text" id="fifth"
                                            maxlength="1" v-on:keyup.enter="goNext($event.target)" />
                                        <BFormInput class="m-2 text-center form-control " type="text" id="sixth"
                                            maxlength="1" v-on:keyup.enter="goNext($event.target)" />
                                    </div>
                                    <InputOtp v-model="otp_number" :length="6" integerOnly />
                                </div>

                                <div class="mt-3">
                                    <a class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"
                                        @click="verifyOTP">Verify Me</a>
                                </div>
                                <div class="text-center mt-4 font-weight-light"> OTP not received? <a
                                        @click="resend_otp" class="text-primary">Resend</a>
                                </div>
                            </form> -->
            </div>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
</template>

<script setup>
/* eslint-disable */
import { onMounted } from "vue";
import router from "@/router";
import { useAuthStore } from "@/store/auth_store";
import InputOtp from "primevue/inputotp";
import { ref } from "vue";
import axios from "axios";
import { toast } from "vue3-toastify";

const auth_store = useAuthStore();
const otp_number = ref(null);
const time_left = ref(null);
const is_timer_On = ref(true);
const is_valid_otp = ref(null);

const OTP = ref({
  otp_id: null,
  otp_number: "",
  otp_is_used: false,
  otp_generated_for_usr_id: 0,
  otp_created_on: new Date(),
  otp_status: 1,
  otp_valid_till: null,
});

const verifyOTP = () => {
  is_valid_otp.value = otp_number.value == "" ? false : true;
  auth_store.loading = true;
  if (
    auth_store.reset_pass_user != undefined &&
    auth_store.reset_pass_user != null
  )
    OTP.value.otp_generated_for_usr_id = auth_store.reset_pass_user.usr_id;
  else OTP.value.otp_generated_for_usr_id = auth_store.registed_user.usr_id;

  OTP.value.otp_number = otp_number.value;
  axios
    .post("/verify_otp", OTP.value)
    .then((res) => {
      if (
        res.data != undefined &&
        res.data != null &&
        res.data.retVal != undefined &&
        res.data.retVal != null &&
        res.data.retVal == 1
      ) {
        if (auth_store.reset_pass_user != null) {
          auth_store.loading = false;
          router.push({ name: "reset-password" });
          toast("Account verified Successfully!!", {
            autoClose: 2000,
            theme: "colored",
            type: "success",
            position: "bottom-center",
            dangerouslyHTMLString: true,
          });
        } else {
          router.push({ name: "login" });
          auth_store.loading = false;
          toast("User Registered Successfully!!", {
            autoClose: 2000,
            theme: "colored",
            type: "success",
            position: "bottom-center",
            dangerouslyHTMLString: true,
          });
        }
      }
    })
    .catch((err) => {
      auth_store.loading = false;
      toast(err.response.data.detail, {
        autoClose: 2000,
        theme: "colored",
        type: "error",
        position: "bottom-center",
        dangerouslyHTMLString: true,
      });
    });
};

onMounted(() => {
  auth_store.loading = false;
  timer(120);
});

function timer(remaining) {
  var m = Math.floor(remaining / 60);
  var s = remaining % 60;

  m = m < 10 ? "0" + m : m;
  s = s < 10 ? "0" + s : s;
  time_left.value = m + ":" + s;
  remaining -= 1;

  if (remaining >= 0 && is_timer_On.value) {
    setTimeout(function () {
      timer(remaining);
    }, 1000);
    return;
  }

  // Do timeout stuff here
  is_timer_On.value = false;
}

const resend_otp = () => {
  auth_store.loading = true;
  if (
    auth_store.reset_pass_user != undefined &&
    auth_store.reset_pass_user != null
  )
    OTP.value.otp_generated_for_usr_id = auth_store.reset_pass_user.usr_id;
  else OTP.value.otp_generated_for_usr_id = auth_store.registed_user.usr_id;

  axios
    .post("/generate_otp", OTP.value)
    .then((res) => {
      auth_store.loading = false;
      timer(120);
    })
    .catch((err) => {
      auth_store.loading = false;
    });
};
</script>

<style scoped>
.digit-box {
  height: 4rem;
  width: 2rem;
  border: 2px solid black;
  display: inline-block;
  border-radius: 5px;
  margin: 5px;
  padding: 15px;
  font-size: 3rem;
}

.digit-box:focus {
  outline: 3px solid black;
}

.p-inputotp-input {
  border-radius: 0;
  font-size: 0.9375rem;
  border: 1px solid #ebedf2;
  margin: 0;
  width: 100%;
  padding: 0;
}

.not-active {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  --bs-text-opacity: 1;
  color: #9c9fa6 !important;
}
</style>
